import React, { useEffect, useRef, useState } from "react";
import "./Home.css";
import Nav from "../../components/Nav/Nav";
import { Link } from "react-router-dom";
import Card from "../../components/Card/Card";
import ContactForm from "../../components/Contact/ContactForm";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import BadgeOutlined from "@mui/icons-material/BadgeOutlined";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import FlagOutlined from "@mui/icons-material/FlagOutlined";
import BalanceOutlined from "@mui/icons-material/BalanceOutlined";

const siteUrl = "https://www.dore-avocat.fr";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LegalService",
      "@id": `${siteUrl}/#cabinet`,
      name: "Cabinet Maître Camille Doré",
      url: siteUrl,
      telephone: "+33322725510",
      email: "avocat.dore@gmail.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "22 rue Lamarck",
        postalCode: "80000",
        addressLocality: "Amiens",
        addressCountry: "FR",
      },
      areaServed: ["Lille", "Paris", "France"],
      description:
        "Cabinet spécialisé en droit des étrangers : titres de séjour, regroupement familial, nationalité française.",
      priceRange: "€€",
      image: `${siteUrl}/images/logocabinet.png`,
    },
    {
      "@type": "Person",
      "@id": `${siteUrl}/#camille-dore`,
      name: "Maître Camille Doré",
      jobTitle: "Avocate",
      description:
        "Avocate au barreau de Lille, spécialisée en droit des étrangers. Lauréate du Prix de la Solidarité 2019 et du titre Prodige de la République 2021.",
      worksFor: { "@id": `${siteUrl}/#cabinet` },
      url: `${siteUrl}/apropos`,
      image: `${siteUrl}/images/camille_compress.jpg`,
      award: [
        "Prix de la Solidarité - Métropole Européenne de Lille (2019)",
        "Prodige de la République - Gouvernement français (2021)",
      ],
    },
  ],
};

function Home(props) {
  const [allPost, setAllPost] = useState([]);
  const [animate, setAnimate] = useState(false);
  const elementRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      if (elementRef.current) {
        const elementPosition = elementRef.current.getBoundingClientRect().top;

        // La valeur 100 représente la distance à partir du haut de la page où l'animation devrait commencer
        if (elementPosition < window.innerHeight - 100) {
          setAnimate(true);
        } else {
          setAnimate(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Nettoyer l'écouteur d'événement lors du démontage du composant
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [elementRef]);

  useEffect(() => {
    axios
      .get("https://api.dore-avocat.fr/api/post")
      .then((response) => {
        setAllPost(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div>
      <Helmet>
        <title>Maître Camille Doré - Avocate en droit des étrangers à Lille</title>
        <meta name="description" content="Cabinet de Maître Camille Doré, avocate au barreau de Lille spécialisée en droit des étrangers. Accompagnement pour titres de séjour, regroupement familial et nationalité française." />
        <link rel="canonical" href={siteUrl} />
        <meta property="og:title" content="Maître Camille Doré - Avocate en droit des étrangers à Lille" />
        <meta property="og:description" content="Cabinet de Maître Camille Doré, avocate au barreau de Lille spécialisée en droit des étrangers. Accompagnement pour titres de séjour, regroupement familial et nationalité française." />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:image" content={`${siteUrl}/images/bio.jpg`} />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="banner">
        <Nav />
        <div className="banner-inner">
          <div className="banner-description">
            <h1>Maître Camille Doré, avocate au barreau de Lille</h1>
          </div>
          <div className="banner-contact-wrapper">
            <ContactForm />
          </div>
        </div>
      </div>
      <div className="bio">
        <div className="bio-wrapper">
          <h2> Bienvenue sur le site de Maître Camille Doré</h2>
          <p>
            Le cabinet vous informe, vous conseille et vous accompagne dans la défense de vos droits.
          </p>

          <Link to="apropos">
            <div className="CTA">Voir plus</div>
          </Link>
        </div>
        <div className="bio-photos">
          <img src="/images/bio.jpg" alt="Maître Camille Doré, avocate au barreau de Lille" />
          <img src="/images/cabinet-entree.jpeg" alt="La porte d'entrée du cabinet" />
          <img src="/images/cabinet-bureau.jpeg" alt="Le bureau de Maître Camille Doré" />
        </div>
      </div>
      <div className="xp">
        <div className="xp-wrapper">
          <div className="xp-content">
            <div className="xp-copy">
              <h2>Droit des <span>étrangers</span></h2>
              <p className="xp-intro">
                Le cabinet vous accompagne dans vos démarches.
              </p>
              <ul className="xp-services">
                <li><span className="xp-icon"><BadgeOutlined /></span><span>Titres de séjour</span></li>
                <li><span className="xp-icon"><GroupsOutlined /></span><span>Regroupement familial</span></li>
                <li><span className="xp-icon"><FlagOutlined /></span><span>Nationalité française</span></li>
                <li><span className="xp-icon"><BalanceOutlined /></span><span>Recours contre les décisions administratives</span></li>
              </ul>
              <Link className="xp-link" to="./étranger">
                En savoir plus <span aria-hidden="true">→</span>
              </Link>
            </div>
            <div className="xp-visual">
              <img
                className="xp-photo"
                src="/images/cabinet-accueil.jpeg"
                alt="L'espace d'accueil du cabinet"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className={`rdv ${animate ? "animer" : ""}`} ref={elementRef}>
        <h2>Rendez-vous</h2>
        <p>
          Prenez rendez-vous avec Maître Camille Doré pour obtenir des conseils
          juridiques personnalisés et confidentiels. Elle comprend l'importance
          d'une assistance juridique adaptée à vos besoins. Que vous ayez besoin
          de conseils, de représentation juridique ou de clarifications sur vos
          droits, son cabinet est à votre service pour vous accompagner et vous
          défendre avec dévouement et professionnalisme.
        </p>
        <Link to="rdv">
          <div className="CTA">Voir plus</div>
        </Link>
      </div> */}
      <div className="blog">
        <div className="blog-inner">
          <div className="title-subtile">
            <h2>Blog</h2>
            <p className="desc">
              Cette rubrique a pour objectif de partager des articles et des
              réflexions sur les problématiques juridiques liées à l'immigration,
              les droits des étrangers et les actualités dans ce domaine. Les
              articles sont rédigés dans une approche pédagogique, afin de fournir
              des informations utiles à ceux qui rencontrent des difficultés
              administratives ou juridiques.
            </p>
          </div>
          {allPost.length === 0 ? (
            <div className="blog-empty">
              <p className="blog-section-null">
                Actuellement, le blog ne comporte aucun article. Nous vous invitons
                à revenir ultérieurement pour découvrir nos prochaines publications.
              </p>
            </div>
          ) : (
            <div className="blog-section">
              {allPost.slice(0, 6).map((item, i) => (
                <div className="dashboard-card">
                  <Card card={item} key={i} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
